export { default } from "./SquareFootageIcon";
